import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';

import Main from './pages/main';
import Uxbooster from './pages/uxbooster';
import Uxboard from './pages/uxboard';
import Uxcreator from './pages/uxcreator';
import Aichanger from './pages/aichanger';
import Si from './pages/si';
import Gems from './pages/gems';
import Epro from './pages/epro';
import Notice from './pages/notice';
import NoticeDetail from './pages/notice-detail';
import Document from './pages/document';
import DocumentDetail from './pages/document-detail';
import TechnicalSupport from './pages/technical-support';
import Contact from 'pages/contact';
import Intro from './pages/intro';
import Ci from './pages/ci';
import License from './pages/license';
import Privacy from './pages/privacy';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Main />} />
          <Route path="/uxbooster" element={<Uxbooster />} />
          <Route path="/uxboard" element={<Uxboard />} />
          <Route path="/uxcreator" element={<Uxcreator />} />
          <Route path="/aichanger" element={<Aichanger />} />
          <Route path="/si" element={<Si />} />
          <Route path="/gems" element={<Gems />} />
          <Route path="/epro" element={<Epro />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/notice-detail" element={<NoticeDetail />} />
          <Route path="/document" element={<Document />} />
          <Route path="/document-detail" element={<DocumentDetail />} />
          <Route path="/technical-support" element={<TechnicalSupport />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/intro" element={<Intro />} />
          <Route path="/ci" element={<Ci />} />
          <Route path="/license" element={<License />} />
          <Route path="/privacy" element={<Privacy />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
